import { getGlobalClassNames, FontSizes } from '../../Styling';
var GlobalClassNames = {
    root: 'ms-GroupShowAll',
    link: 'ms-Link'
};
export var getStyles = function (props) {
    var theme = props.theme;
    var classNames = getGlobalClassNames(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'relative',
                padding: '10px 84px',
                cursor: 'pointer',
                selectors: (_a = {},
                    _a["." + classNames.link] = {
                        fontSize: FontSizes.small
                    },
                    _a)
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=GroupShowAll.styles.js.map